export default "__VITE_ASSET__vIespYX4__"